export default __webpack_public_path__ + "static/cps-4f15590ce3450280f9cd9105ece06433.png";